import styled from 'styled-components';

const EmptyState = styled.div`
  padding: 50px;
  text-align: center;
`;

export default EmptyState;
